import React from "react";

import { pluralize } from "@common/helpers/string";
import { FiltersTypes } from "@common/types/filters/general";
import { ClassFilterType } from "@common/types/class";
import { useClasses } from "@api/class.api";
import { BreakableText } from "@design-system/BreakableText/BreakableText";

interface ClassFilterLabelProps {
    filters: Pick<FiltersTypes, "classes" | "classFilterType">;
}

const classFilterTypeToLabel = {
    [ClassFilterType.ALL_SELECTED]: "Every: ",
    [ClassFilterType.ANY_SELECTED]: "Any: ",
    [ClassFilterType.EXCLUDE_SELECTED]: "Exclude: ",
    [ClassFilterType.NO_CLASSES]: "No ",
    [ClassFilterType.HAS_CLASSES]: "Has ",
};

export const ClassFilterLabel: React.FC<ClassFilterLabelProps> = ({
    filters: { classes: classIds, classFilterType },
}) => {
    const { classesMap } = useClasses();

    if (
        classIds?.length === 0 ||
        classFilterType === ClassFilterType.NO_CLASSES
    ) {
        return "No classes";
    }

    if (classFilterType === ClassFilterType.HAS_CLASSES) {
        return "Has class";
    }

    if (!classIds) {
        return null;
    }

    const classFilterTypeWithDefault =
        classFilterType ?? ClassFilterType.ANY_SELECTED;

    if (classIds?.length === 1) {
        return (
            <BreakableText
                text={`${classFilterTypeToLabel[classFilterTypeWithDefault]} ${classesMap.get(classIds[0])?.label}`}
            />
        );
    }

    return (
        <BreakableText
            text={`${classFilterTypeToLabel[classFilterTypeWithDefault]} ${classIds?.length} ${pluralize("Class", classIds?.length)}`}
        />
    );
};
